module.exports = __webpack_public_path__ + "assets/img/img263.c145e6d2.png";